import { useEffect, useState } from "react";

const DOCK_BREAKPOINT = 1280;

function getCanDock() {
  return window.matchMedia(`(min-width: ${DOCK_BREAKPOINT}px)`).matches;
}

/** Returns true when the viewport is wide enough to dock the inspector inline. */
export function useCanDockInspector(): boolean {
  const [canDock, setCanDock] = useState(() =>
    typeof window !== "undefined" ? getCanDock() : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${DOCK_BREAKPOINT}px)`);
    const handler = (e: MediaQueryListEvent) => setCanDock(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return canDock;
}
